import React from "react";
import ErrorWrapper from "./ErrorWrapper";
import cogniLogo from "../../images/cogni_logo.png";
import ErrorImage from "../../images/error.png";
import "./error.css";

export default () => {
  return (
    <ErrorWrapper>
      <div className="col-md-12 col-lg-12 expired_alert_login_bg_width_left">
        <img
          className="centerImage"
          src={cogniLogo}
          alt="Assistant"
          title="Assistant"
        />
        <h2>Access error</h2>
        <p>The invitation might be cancelled or invalid.</p>
        <div className="expired_alert_left_bottom_img">
          <img
            src={ErrorImage}
            align="middle"
            alt="Link_expired"
            title="Link_expired"
          />
        </div>
      </div>
    </ErrorWrapper>
  );
};
